function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgBee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B414B"
    },
    d: "M239.754,89.4c-2.54,0-5.032-1.183-6.619-3.405c-38.539-53.952-92.603-69.896-93.142-70.051 c-4.317-1.234-6.817-5.73-5.587-10.048c1.238-4.321,5.762-6.813,10.048-5.579c2.436,0.694,60.103,17.706,101.904,76.234 c2.611,3.651,1.762,8.726-1.889,11.337C243.04,88.908,241.389,89.4,239.754,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B414B"
    },
    d: "M272.246,89.4c-1.635,0-3.286-0.492-4.714-1.512c-3.651-2.611-4.5-7.686-1.889-11.337 c41.801-58.528,99.467-75.54,101.904-76.234c4.31-1.238,8.794,1.262,10.032,5.571s-1.246,8.805-5.556,10.052 c-0.548,0.159-54.785,16.333-93.158,70.055C277.278,88.217,274.786,89.4,272.246,89.4z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6E555E"
    },
    cx: 256,
    cy: 103.28,
    rx: 45.04,
    ry: 43.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFDC64"
    },
    cx: 256,
    cy: 154.41,
    rx: 73.14,
    ry: 65.02
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M223.492,154.415c0-29.633,22.326-54.587,52.825-62.42C269.86,90.337,263.058,89.4,256,89.4 c-40.396,0-73.142,29.108-73.142,65.015S215.605,219.43,256,219.43c7.058,0,13.86-0.937,20.317-2.595 C245.818,209.002,223.492,184.048,223.492,154.415z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6E555E"
    },
    cx: 256,
    cy: 365.71,
    rx: 121.9,
    ry: 146.28
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F4B55"
    },
    d: "M215.365,365.715c0-59.077,17.893-111.718,45.802-145.972c-1.727-0.087-3.423-0.313-5.167-0.313 c-67.326,0-121.904,65.494-121.904,146.285C134.096,446.506,188.674,512,256,512c1.745,0,3.44-0.226,5.167-0.313 C233.259,477.433,215.365,424.792,215.365,365.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M256,349.461c43.588,0,83.233-14.124,113.396-37.172C351.6,257.954,307.595,219.43,256,219.43 s-95.601,38.523-113.396,92.859C172.767,335.337,212.412,349.461,256,349.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M256,219.431c-33.798,0-64.265,16.615-86.306,43.303c-0.007-0.009-0.017-0.018-0.024-0.027 c-0.178,0.216-0.33,0.461-0.507,0.678c-2.238,2.743-4.417,5.555-6.472,8.5c0.017,0.024,0.04,0.044,0.057,0.067 c-8.39,11.988-15.29,25.519-20.143,40.337c20.641,15.772,45.788,27.218,73.533,32.967c0.582-8.182,1.535-16.185,2.808-23.994 c1.398-8.573,9.352-14.302,17.992-13.404c6.077,0.631,12.425,0.97,19.063,0.97c43.997,0,76.678-13.525,93.31-36.942 C326.978,239.868,293.525,219.431,256,219.431z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B414B"
    },
    d: "M312.889,219.431H199.112c-1.683,0-3.325-0.524-4.706-1.5l-50.389-35.762 c-6.27-4.69-9.921-11.984-9.921-19.627v-9.52c0-2.171-0.849-4.214-2.381-5.75l-44-44c-3.175-3.175-3.175-8.317,0-11.492 c3.175-3.175,8.317-3.175,11.492,0l44,44c4.603,4.603,7.143,10.73,7.143,17.242v9.52c0,2.548,1.214,4.972,3.238,6.492 l48.111,34.143h108.602l48.27-34.262c1.865-1.401,3.079-3.829,3.079-6.373v-9.52c0-6.512,2.54-12.639,7.143-17.242l44-44 c3.175-3.175,8.317-3.175,11.492,0c3.175,3.175,3.175,8.317,0,11.492l-44,44c-1.532,1.536-2.381,3.579-2.381,5.75v9.52 c0,7.635-3.643,14.928-9.754,19.5l-50.555,35.889C316.214,218.907,314.571,219.431,312.889,219.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B414B"
    },
    d: "M459.165,284.446c-1.833,0-3.675-0.619-5.198-1.881l-41.984-34.984 c-2.913-2.429-6.603-3.77-10.397-3.77H110.414c-3.794,0-7.484,1.341-10.397,3.77l-41.984,34.984 c-3.46,2.865-8.571,2.405-11.452-1.04c-2.873-3.452-2.405-8.579,1.04-11.452l41.984-34.984c5.833-4.857,13.222-7.532,20.809-7.532 h291.173c7.587,0,14.976,2.675,20.809,7.532l41.984,34.984c3.444,2.873,3.913,8,1.04,11.452 C463.808,283.454,461.499,284.446,459.165,284.446z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M377.674,360.243c-26.235,25.259-70.923,41.906-121.674,41.906s-95.438-16.647-121.674-41.906 c-0.057,2.02-0.23,4-0.23,6.038c0,5.963,0.283,11.834,0.759,17.63c29.766,38.619,72.938,63.073,121.145,63.073 s91.379-24.454,121.145-63.073c0.476-5.796,0.759-11.667,0.759-17.63C377.904,364.243,377.73,362.263,377.674,360.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M217.472,398.776c-34.416-6.045-63.813-19.919-83.146-38.533c-0.001,0.012-0.001,0.024-0.001,0.036 c-0.054,1.909-0.202,3.785-0.217,5.705c0.009,6.225,0.444,12.319,1.082,18.339c23.539,30.359,55.398,51.846,91.459,59.518 C222.385,429.69,219.319,414.575,217.472,398.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M113.779,410.413l-66.853,32.104c-19.83,9.587-42.86-4.86-42.86-26.886l0,0 c0-21.554,8.562-42.225,23.803-57.466L172.7,213.334l3.386,34.201L113.779,410.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M173.704,223.483l-56.665,102.555l-52.085,12.82c-9.436,2.325-18.471,5.616-27.242,9.464 l-9.843,9.843c-7.224,7.225-12.89,15.695-16.913,24.876l1.07-0.834c16.897-13.167,36.016-22.444,56.817-27.571l37.494-9.229 l-7.055,12.767c-11.891,21.521-27.911,40.484-47.142,55.804L18.207,441.01c8.217,5.091,18.861,6.273,28.719,1.507l66.853-32.104 l62.307-162.877L173.704,223.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M176.085,247.536l-66.982,155.141c-5.756,13.315,7.488,26.929,20.956,21.542l31.443-12.577 c8.173-3.269,13.949-10.69,15.112-19.415l16.403-124.373L176.085,247.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M147.073,417.413l14.429-5.771c8.173-3.269,13.949-10.69,15.112-19.415l16.403-124.373l-11.36-13.632 L147.073,417.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M398.221,410.413l66.853,32.104c19.83,9.587,42.86-4.86,42.86-26.886l0,0 c0-21.554-8.562-42.225-23.803-57.466l-144.83-144.83l-3.386,34.201L398.221,410.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M338.296,223.483l56.665,102.555l52.085,12.82c9.436,2.325,18.471,5.616,27.242,9.464l9.843,9.843 c7.224,7.225,12.89,15.695,16.913,24.876l-1.07-0.834c-16.897-13.167-36.016-22.444-56.817-27.571l-37.494-9.229l7.055,12.767 c11.891,21.521,27.911,40.484,47.142,55.804l33.934,27.032c-8.217,5.091-18.861,6.273-28.719,1.507l-66.853-32.104l-62.307-162.877 L338.296,223.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M335.915,247.536l66.982,155.141c5.756,13.315-7.488,26.929-20.956,21.542l-31.443-12.577 c-8.173-3.269-13.949-10.69-15.112-19.415l-16.403-124.373L335.915,247.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M364.927,417.413l-14.429-5.771c-8.173-3.269-13.949-10.69-15.112-19.415l-16.403-124.373 l11.36-13.632L364.927,417.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E555E"
    },
    d: "M256,154.415c49.372,0,89.396,34.566,89.396,77.206S305.372,292.573,256,292.573 s-89.396-18.312-89.396-60.952S206.628,154.415,256,154.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F4B55"
    },
    d: "M223.492,212.737c0-21.827,7.589-41.845,20.216-57.508c-43.54,5.185-77.105,37.363-77.105,76.392 c0,42.64,40.024,60.952,89.396,60.952c18.784,0,36.195-2.67,50.583-8.303C260.165,282.48,223.492,260.739,223.492,212.737z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBee);
export default __webpack_public_path__ + "static/media/bee.f7c27204.svg";
export { ForwardRef as ReactComponent };